import React from 'react'
import { Route, Switch } from 'react-router-dom'
import CreateSummary from './CreateSummary'

const Paraphrase = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/`} component={CreateSummary} />
    </Switch>
  </div>
)
export default Paraphrase
